import React from "react";
import { PaymentSuccessModalTemplate } from "themes/application/payment/components";

function PaymentSuccessModal(props) {
    return <PaymentSuccessModalTemplate {...props} />;
}

export default PaymentSuccessModal;
